import Left from 'assets/icons/Left';
import Button from 'common/components/Button';
import Divider from 'common/components/Divider';
import { cn } from 'common/utils';
import React, { useEffect } from 'react';
import { useIntegrationSettings } from 'settings/contexts/IntegrationSettingsContext';

import { IntegrationStatus } from './IntegrationCard';

const IntegrationFormTemplate = ({ children }) => {
  const {
    selectedIntegration,
    setSelectedIntegration,
    currentTab,
    setCurrentTab,
  } = useIntegrationSettings();

  useEffect(() => {
    if (selectedIntegration?.tabs?.length) {
      setCurrentTab(selectedIntegration.tabs[0]);
    }
  }, [selectedIntegration]);

  return (
    <div className='flex flex-col h-full p-6 bg-white'>
      <div className='mb-4 flex items-center'>
        <Button
          type='button'
          variant='secondary'
          onClick={() => setSelectedIntegration(null)}
          size='16'
          className='flex items-center gap-2 text-sm px-4 py-2 bg-vibrant-orange text-white hover:bg-orange-500 rounded-md'
        >
          <Left size='16px' color='#ffffff' />
        </Button>
      </div>

      <div className='flex justify-between items-center mb-6'>
        <div className='flex items-center gap-2'>
          {selectedIntegration?.icon}
          <h2 className='font-semibold text-xl'>{selectedIntegration?.name}</h2>
        </div>
        {selectedIntegration.status() ?? (
          <IntegrationStatus integration={selectedIntegration} />
        )}
      </div>

      {currentTab && (
        <>
          <div className='flex items-center justify-between mb-3.5 z-10'>
            <ul className='flex items-center gap-4'>
              {selectedIntegration?.tabs?.map((tab) => (
                <li
                  key={tab.slug}
                  className={cn(
                    'font-semibold select-none text-sonic-silver cursor-pointer',
                    {
                      'text-vibrant-orange decoration-2 underline underline-offset-[20px] cursor-auto':
                        tab.slug === currentTab?.slug,
                    },
                  )}
                  onClick={() => setCurrentTab(tab)}
                >
                  {tab.label}
                </li>
              ))}
            </ul>
          </div>
          <Divider />
        </>
      )}
      <div className='p-6'>{children}</div>
    </div>
  );
};

export default IntegrationFormTemplate;
